import {Button} from 'antd'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import usePreviewUi from './usePreviewUi.jsx'

export default function PropertiesControllerPreview(props) {
    const filterByLicense = useFilterByLicense()
    const previewUi = usePreviewUi()
    const map = useMapContext()
    const [node] = map.useSelectedNodes()

    if (! node.parent) {
        return null
    }

    const handleClick = async e => {
        const target = e.altKey ? '_self' : '_blank'
        previewUi(map, node, target)
    }

    return filterByLicense('M00030002',
        <Button
            onClick={handleClick}
            {...props}
        >
            界面看板
        </Button>
    )
}
